export const RSVP_FIELD_DEFS = [
  { id: 'guestCount', label: 'How many people are coming?', description: 'Total headcount including the respondent' },
  { id: 'guestNames', label: 'Guest names', description: 'Name for each person attending' },
  { id: 'guestAges', label: 'Ages', description: 'Age for each guest' },
  { id: 'foodPreference', label: 'Food preference', description: 'Dietary / meal preference per guest' },
  { id: 'drinkPreference', label: 'Drinks', description: 'Alcohol or non-alcohol per guest' },
];

export const FOOD_PREFERENCE_OPTIONS = [
  { id: 'VEG', label: 'Veg' },
  { id: 'NON_VEG', label: 'Non-veg' },
];

export const DRINK_PREFERENCE_OPTIONS = [
  { id: 'ALCOHOL', label: 'Alcohol' },
  { id: 'NON_ALCOHOL', label: 'Non-alcohol' },
];

export const DEFAULT_RSVP_FIELDS = {
  guestCount: { enabled: true, required: true },
  guestNames: { enabled: true, required: true },
  guestAges: { enabled: true, required: false },
  foodPreference: { enabled: true, required: true },
  drinkPreference: { enabled: true, required: true },
};

export const createCustomRsvpField = (label) => ({
  id: `custom_${Date.now().toString(36)}_${Math.random().toString(36).slice(2, 6)}`,
  label: String(label || '').trim(),
  type: 'text',
  required: true,
});

export const getCustomRsvpFields = (fields) => {
  const raw = fields?.customFields;
  if (!Array.isArray(raw)) return [];
  return raw
    .map((field) => {
      if (!field || typeof field !== 'object') return null;
      const label = String(field.label || '').trim();
      const id = String(field.id || '').trim();
      if (!label || !id) return null;
      return {
        id,
        label,
        type: 'text',
        required: field.required === true || field.required === 'true' || field.required === 1,
      };
    })
    .filter(Boolean);
};

export const normalizeRsvpFields = (fields) => {
  const base = RSVP_FIELD_DEFS.reduce((acc, { id }) => {
    acc[id] = { enabled: false, required: false };
    return acc;
  }, {});
  if (!fields || typeof fields !== 'object') {
    base.customFields = [];
    return base;
  }
  RSVP_FIELD_DEFS.forEach(({ id }) => {
    const raw = fields[id];
    if (!raw || typeof raw !== 'object') return;
    base[id] = {
      enabled: raw.enabled === true || raw.enabled === 'true' || raw.enabled === 1,
      required: raw.required === true || raw.required === 'true' || raw.required === 1,
    };
  });
  base.customFields = getCustomRsvpFields(fields);
  return base;
};

export const hasEnabledRsvpFields = (fields) => {
  const normalized = normalizeRsvpFields(fields);
  return RSVP_FIELD_DEFS.some(({ id }) => normalized[id]?.enabled) || getCustomRsvpFields(fields).length > 0;
};

/** Ask RSVP questions on accept whenever any collectable fields are enabled. */
export const needsRsvpDetailsOnAccept = (responseType, fields) => {
  const type = (responseType || '').toUpperCase();
  if (type === 'NONE' || type === 'POLL' || type === 'MULTIPLE_CHOICE') return false;
  return hasEnabledRsvpFields(fields);
};
